"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONInlinePictureSizeConverterConverter = void 0;
var common_1 = require("@devexpress/utils/lib/utils/common");
var sizes_1 = require("../../../../floating-objects/sizes");
var json_floating_enums_1 = require("../../../enums/json-floating-enums");
var json_importer_1 = require("../../json-importer");
var JSONInlinePictureSizeConverterConverter = (function () {
    function JSONInlinePictureSizeConverterConverter() {
    }
    JSONInlinePictureSizeConverterConverter.convertFromJSON = function (obj, cacheInfo) {
        return new sizes_1.PictureSize(!!obj[json_floating_enums_1.JSONAnchorInlineBaseSize.LockAspectRatio], obj[json_floating_enums_1.JSONAnchorInlineBaseSize.Rotation], cacheInfo, json_importer_1.SizeExporter.convertFromJSON(obj[json_floating_enums_1.JSONPictureSize.Scale]));
    };
    JSONInlinePictureSizeConverterConverter.convertToJSON = function (source) {
        var result = {};
        result[json_floating_enums_1.JSONAnchorInlineBaseSize.LockAspectRatio] = common_1.boolToInt(source.lockAspectRatio);
        result[json_floating_enums_1.JSONAnchorInlineBaseSize.Rotation] = source.rotation;
        result[json_floating_enums_1.JSONPictureSize.Scale] = json_importer_1.SizeExporter.convertToJSON(source.scale);
        return result;
    };
    return JSONInlinePictureSizeConverterConverter;
}());
exports.JSONInlinePictureSizeConverterConverter = JSONInlinePictureSizeConverterConverter;
